<template>
  <section class="section container" style="padding-top:120px; max-width:600px">
    <div class="glass" style="padding:20px">
      <h1 class="h2" style="margin-bottom:16px">管理員：手動授權用戶</h1>
      <p style="margin-bottom:16px;font-size:14px;opacity:.8">
        輸入用戶 Email，系統會：若不存在則建立帳號＋個人資料，並授權 product_id = 1。
      </p>

      <form @submit.prevent="handleSubmit">
        <label class="label" style="display:block;margin-bottom:8px">
          用戶 Email：
        </label>
        <input
          v-model="email"
          type="email"
          required
          placeholder="user@example.com"
          class="input"
          style="width:100%;padding:8px 10px;border-radius:6px;border:1px solid #ccc;margin-bottom:12px"
        />

        <button
          type="submit"
          :disabled="loading || !email"
          style="padding:8px 16px;border-radius:999px;border:none;background:#4f46e5;color:white;cursor:pointer"
        >
          {{ loading ? '處理中…' : '提交授權' }}
        </button>
      </form>

      <p
        v-if="message"
        :style="{
          marginTop:'12px',
          fontSize:'14px',
          color: messageColor
        }"
      >
        {{ message }}
      </p>
    </div>
  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AdminEnrollEmail',

  data () {
    return {
      email: '',
      loading: false,
      message: '',
      messageColor: '#16a34a'
    }
  },

  computed: {
    apiBase () {
      // ✅ Vue CLI 用 process.env.VUE_APP_XXX
      return process.env.VUE_APP_API_BASE || 'https://web3schoolapi.web3school.info'
    }
  },

  methods: {
    async handleSubmit () {
      this.message = ''
      this.messageColor = '#16a34a'

      if (!this.email) return

      this.loading = true

      try {
        const token = localStorage.getItem('web3school_token') || ''

        const resp = await axios.post(
          `${this.apiBase}/api/admin/enroll-email`,
          { email: this.email },
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : ''
            }
          }
        )

        if (resp.data && resp.data.ok) {
          this.message = `✅ 已處理：${resp.data.email}（user_id=${resp.data.user_id}）`
          this.email = ''
        } else {
          this.messageColor = '#dc2626'
          this.message = `❌ 失敗：${resp.data?.error || 'UNKNOWN'}`
        }
      } catch (err) {
        this.messageColor = '#dc2626'
        this.message = `❌ 請求錯誤：${err.response?.data?.error || err.message}`
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
